import {Component} from "@angular/core";

/**
 * ░█▀▄░▀▀█░▀▀█░█▀█░█▀█░█▀█
 * ░█░█░░▀▄░░▀▄░█▀▀░█▀█░█░█
 * ░▀▀░░▀▀░░▀▀░░▀░░░▀░▀░▀░▀
 *
 * @author d33pan on 7/8/2026
 */
@Component({
  selector: 'app-form-card-body',
  standalone: true,
  template: `<div class="w-full"><ng-content></ng-content></div>`,
  styles: []
})
export class FormCardBodyComponent {}
